import PropTypes from 'prop-types';

export const TabType = Object.freeze({
    FLIGHTS: 'flights',
    HOTELS: 'hotels',
    DP: 'dp',
    TRAINS: 'trains',
    CARS: 'cars',
    HOLIDAYSPACKAGES: 'holidaypackages',
    VP: 'vp',
    DEALS: 'deals'
});

export const TabTypeProp = PropTypes.oneOf(Object.values(TabType));
export const TabTypePropDefault = TabType.FLIGHTS;
